import { z } from 'zod';
import { WorkflowWriteBackMode } from 'libs/end-to-end/src/types/databases/workflows/workflow-write-back-mode';
import { WriteBackToLeverStrategy } from 'libs/end-to-end/src/types/databases/workflows/strategies/lever-write-back';
import { WriteBackToWorkdayViaWsStrategy } from 'libs/end-to-end/src/types/databases/workflows/strategies/workday-write-back';

export const WorkflowAIInterviewerV2WriteBackStrategy = z.union([
  WriteBackToWorkdayViaWsStrategy,
  WriteBackToLeverStrategy,
]);

export type WorkflowAIInterviewerV2WriteBackStrategy = z.infer<
  typeof WorkflowAIInterviewerV2WriteBackStrategy
>;

export const WorkflowAIInterviewerV2WriteBackDetails = z.object({
  type: z.literal('aiInterviewerV2WriteBack'),
  strategy: WorkflowAIInterviewerV2WriteBackStrategy.nullish(),
  mode: WorkflowWriteBackMode.optional(),
  numPreviousDaysOfApplicants: z.number().optional(),
  numberOfSamplesToSend: z.number().optional(),
  dataSetId: z.string().optional(),
});

export type WorkflowAIInterviewerV2WriteBackDetails = z.infer<
  typeof WorkflowAIInterviewerV2WriteBackDetails
>;
